import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop errors - these are often benign browser quirks
// that occur when ResizeObserver callbacks trigger layout changes
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Suppress this specific error - it's a known browser quirk
    return;
  }
  originalError.apply(console, args);
};

// Also suppress in window error handler
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
    event.stopPropagation();
  }
});

// Mobile wrapper component that provides mobile context to App
function MobileWrapper() {
  return <App isMobile={true} />;
}

// Desktop wrapper component
function DesktopWrapper() {
  return <App isMobile={false} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/m/*" element={<MobileWrapper />} />
      <Route path="/*" element={<DesktopWrapper />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
